<template>
  <div>
    <v-responsive v-if="!images || images.length === 0" :aspect-ratio="2">
      <v-skeleton-loader
          type="image"
          width="100%"
          height="100%"
          boilerplate
      ></v-skeleton-loader>
    </v-responsive>
    <v-carousel
            v-else
            height="auto"
            cycle
            show-arrows-on-hover
            hide-delimiter
            hide-delimiter-background
            v-model="currentImg"
    >
      <v-carousel-item
              v-for="(slide, i) in images"
              :key="i"
              eager
              aspect-ratio="2"
      >
        <div class="fill-height" align="center" justify="center">
          <v-img
                  alt="tcdc-image"
                  :src="slide.slide_image"
                  aspect-ratio="2"
                  eager
                  :contain="contain"
                  @click="clickSeeBigger"
          >
            <template v-slot:placeholder>
              <v-sheet class="fill-height" color="#EFEFEF"></v-sheet>
            </template>
          </v-img>
        </div>
      </v-carousel-item>
    </v-carousel>
    <v-dialog fullscreen overlay-opacity=".8" width="100%" v-model="seeBigger">
<!--      <v-btn fab small absolute right class="ma-3" style="right: 25px;" color="#2e8037" @click="seeBigger = false">-->
<!--        <v-icon color="#fff">mdi-close</v-icon>-->
<!--      </v-btn>-->
      <div class="fill-height d-flex align-center" style="background: white">
        <v-carousel
                height="auto"
                show-arrows-on-hover
                hide-delimiter
                hide-delimiter-background
                v-model="currentImg"
        >
          <v-snackbar v-model="snackbar" :timeout="3000" transition="scale-transition">
            <span style="font-family: Poppins, Kanit;">{{ $t('carousel.click-any-close') }}</span>
            <template v-slot:action="{ attrs }">
              <v-btn
                      color="#2e8037"
                      icon
                      v-bind="attrs"
                      @click="snackbar = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </template>
          </v-snackbar>
          <v-carousel-item
                  v-for="(slide, i) in images"
                  :key="i"
                  eager
                  aspect-ratio="2"
          >
            <v-row class="fill-height" align="center" justify="center">
              <img
                      @click="seeBigger = false"
                      class="image-full"
                      :src="slide.slide_image"
              >
            </v-row>
          </v-carousel-item>
        </v-carousel>
      </div>
    </v-dialog>
  </div>
</template>

<script>
// import axios from "axios";

export default {
  props: {
    images : {
      type: Array,
    },
    contain: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    snackbar: false,
    seeBigger: false,
    currentImg: 0
  }),
  methods: {
    clickSeeBigger() {
      this.seeBigger = !this.seeBigger;
      if (this.seeBigger) {
        this.snackbar = true;
      }
    }
  }
};
</script>

<style>
  .image-full {
    display: block;
    max-height: 100vh;
    width: 100%;
    height: auto;
  }
</style>
